import React, { useEffect, useState } from "react";
import "./Summary.css";
import { getPerformanceSummary } from "../../../../utils/apis/performance/performance";

const Summary = () => {
  const [summaryData, setSummaryData] = useState({});
  const getSummary = async () => {
    const res = await getPerformanceSummary();
    if (res?.success) {
      setSummaryData(res.data);
    }
  };

  useEffect(() => {
    getSummary();
  }, []);
  return (
    <section className="Summary">
      <div className="row p-2">
        <div className="col-xl-3 col-sm-6 p-0 mb-2 ">
          <div className="card_div border_right">
            <div className="head_div">
              <p className="title_text ">Net Profit</p>
              <p
                className={`amount_text ${
                  Number(summaryData?.totalProfit) < 0
                    ? " red_text"
                    : " green_text"
                }`}
              >
                {(summaryData?.totalProfit || 0).toFixed(2)} $
              </p>
            </div>
          </div>
        </div>

        {/* <div className="col-xl-3 col-sm-6 p-0 mb-2 ">
          <div className="card_div border_right">
            <div className="head_div">
              <p className="title_text ">Closed Orders</p>
              <p className="amount_text ">
                {summaryData?.totalClosedOrderCount || 0}
              </p>
            </div>
           
          </div>
        </div>

        <div className="col-xl-3 col-sm-6 p-0 mb-2 ">
          <div className="card_div border_right">
            <div className="head_div">
              <p className="title_text red_text">Net Loss</p>
              <p className="amount_text red_text">
                {summaryData?.totalLoss?.toFixed(2) || 0} $
              </p>
            </div>
           
          </div>
        </div>

        <div className="col-xl-3 col-sm-6 p-0 mb-2">
          <div className="card_div">
            <div className="head_div">
              <p
                className={`title_text ${
                  summaryData?.overall?.status === "loss"
                    ? "red_text"
                    : "green_text"
                }`}
              >
                Total P & L
              </p>
              <p
                className={`amount_text ${
                  summaryData?.overall?.status === "loss"
                    ? "red_text"
                    : "green_text"
                }`}
              >
                {summaryData?.overall?.amount?.toFixed(2) || 0} $
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Summary;
